/* Ezzyrol collection grid: live filters, sort, phone filter drawer, "Show more".
   Progressive: without this file the filter form submits as a plain GET and "Show more" is a link
   to the next page. With it, each change fetches only this section (Section Rendering API) and
   swaps it in place, keeping the drawer open and focus where it was. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 989px)');

  function root(el) { return el && el.closest('[data-ez-coll]'); }
  function form(r) { return r.querySelector('[data-ez-facets]'); }

  function urlFor(r) {
    var f = form(r);
    var params = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var q = params.toString();
    return f.getAttribute('action') + (q ? '?' + q : '');
  }

  function openDrawer(r, open) {
    var f = form(r), btn = r.querySelector('[data-ez-facets-open]');
    if (!f) return;
    if (open) {
      f.setAttribute('data-open', '');
      document.documentElement.classList.add('ez-lock');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      var first = f.querySelector('[data-ez-facets-close]');
      if (first) first.focus();
    } else {
      f.removeAttribute('data-open');
      document.documentElement.classList.remove('ez-lock');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    }
  }

  function load(r, url, opts) {
    opts = opts || {};
    var id = r.getAttribute('data-ez-coll');
    var wasOpen = form(r) && form(r).hasAttribute('data-open');
    var active = document.activeElement && r.contains(document.activeElement) ? document.activeElement.id : null;
    var scroll = form(r) && form(r).querySelector('.ez-facets__body') ? form(r).querySelector('.ez-facets__body').scrollTop : 0;
    r.setAttribute('aria-busy', 'true');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-ez-coll]');
        if (!next) throw new Error('no section');
        if (opts.append) {
          var grid = r.querySelector('[data-ez-grid]'), items = next.querySelectorAll('[data-ez-grid] > li');
          var firstNew = null;
          items.forEach(function (li) { grid.appendChild(li); if (!firstNew) firstNew = li; });
          var more = r.querySelector('[data-ez-more]'), nmore = next.querySelector('[data-ez-more]');
          if (more && nmore) { var prev = nmore.querySelector('[data-ez-prev]'); if (prev) prev.remove(); more.replaceWith(nmore); }
          if (firstNew) { var a = firstNew.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
        } else {
          r.innerHTML = next.innerHTML;
          history.replaceState(history.state, '', url);
          init(r);
          if (wasOpen && mq.matches) {
            form(r).setAttribute('data-open', '');
            var b = form(r).querySelector('.ez-facets__body'); if (b) b.scrollTop = scroll;
          }
          if (active) { var el = document.getElementById(active); if (el) el.focus({ preventScroll: true }); }
        }
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { r.removeAttribute('aria-busy'); });
  }

  var timer;
  /* every listener is delegated from the section root, which survives each swap */
  function init(r) {
    var f = form(r);
    if (f) f.setAttribute('data-ez-live', '');
    if (r.hasAttribute('data-ez-bound')) return;
    r.setAttribute('data-ez-bound', '');
    r.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ez-price]')) return;
      if (t.matches('[data-ez-sort]') || t.closest('[data-ez-facets]')) load(r, urlFor(r));
    });
    r.addEventListener('input', function (e) {
      if (!e.target.matches('[data-ez-price]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { load(r, urlFor(r)); }, 700);
    });
    r.addEventListener('submit', function (e) {
      var f = form(r);
      if (e.target !== f) return;
      e.preventDefault();
      if (f.hasAttribute('data-open')) { openDrawer(r, false); return; }
      load(r, urlFor(r));
    });
    r.addEventListener('keydown', function (e) {
      var f = form(r);
      if (e.key === 'Escape' && f && f.hasAttribute('data-open')) openDrawer(r, false);
    });
    r.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ez-facets-open],[data-ez-facets-close],[data-ez-nav],[data-ez-more-link]');
      if (!t || !r.contains(t)) return;
      if (t.hasAttribute('data-ez-facets-open')) { openDrawer(r, true); return; }
      if (t.hasAttribute('data-ez-facets-close')) { openDrawer(r, false); return; }
      e.preventDefault();
      if (t.hasAttribute('data-ez-more-link')) {
        if (t.getAttribute('aria-disabled') === 'true') return;
        t.setAttribute('aria-disabled', 'true');
        load(r, t.getAttribute('href'), { append: true });
      } else {
        load(r, t.getAttribute('href'));
      }
    });
  }

  mq.addEventListener('change', function () {
    document.querySelectorAll('[data-ez-facets][data-open]').forEach(function (f) { openDrawer(root(f), false); });
  });
  function boot() { document.querySelectorAll('[data-ez-coll]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
